import BaseElement from './BaseElement';

export default class TextElement extends BaseElement.extend({}) {
  getValue() {
    return this.getUI('element').val();
  }
  setValue(value) {
    this.getUI('element').val(value);
  }
}